export const Helpers = {
    AccountingImport: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `G6Fsr842p2A`,
                timer: "02:11 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente ao seu sistema contábil.",
                extLinks: [
                    {
                        label: "Lista de sistemas contábeis",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/tutorial-para-gerar-balancete"
                    },
                    {
                        label: "Como ajustar o balancete",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-importar-os-balancetes-contabeis"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Contabil.Video.Util.Sim",
                    "CentralAjuda.Importacao.Contabil.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Como importar o balancete sem erros",
            icon: "fas fa-list",
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Abaixo estão listados os principais pontos de atenção antes de importar o balancete:",
                topics: [
                    "Balancete precisa conter a coluna de códigos e classificadores. ",
                    "O saldo final de uma conta deve ser igual ao saldo inicial do mês seguinte.",
                    "Os balancetes não podem ser  encerrados.",
                    "Nome do arquivo com formato incompatível.",
                    "Somente balancetes mensais, sendo um arquivo para cada mês.",
                    "Não é possivel subir 2 contas com o mesmo código ou classificador.",
                    "Balancetes de Janeiro precisa estar com saldo atual zerado."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-importar-os-balancetes-contabeis"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Contabil.ComoImportar.Util.Sim",
                    "CentralAjuda.Importacao.Contabil.ComoImportar.Util.Nao"
                ]
            }
        },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Como ajustar o balancete para o padrão Nucont",
            icon: "fas fa-table",
            preview: "Tópicos",
            content: {
                topicsTitle: "É obrigatório ter as 7 colunas listadas abaixo:",
                topics: [
                    "Código da Conta",
                    "Classificador Contábil",
                    "Descrição da Conta",
                    "Saldo Anterior",
                    "Débito",
                    "Crédito",
                    "Saldo Final"
                ],
                extLinks: [
                    {
                        label: "Ver exemplo de arquivo",
                        href: "https://19520802.fs1.hubspotusercontent-na1.net/hubfs/19520802/Produto/Central%20de%20Ajuda%20na%20Feature/Balancete%20padr%C3%A3o%20Nucont.pdf"
                    },
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-importar-os-balancetes-contabeis"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Contabil.ComoAjustar.Util.Sim",
                    "CentralAjuda.Importacao.Contabil.ComoAjustar.Util.Nao"
                ]
            }
        },
        { title: true, label: "A importação falhou?" },
        {
            type: "alerts",
            label: "Alertas",
            labelTitle: "Como resolver os erros e inconsistências ao importar",
            icon: [
                "fas fa-exclamation-triangle alert left",
                "fas fa-exclamation-circle warning right"
            ],
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Dois tipos de alertas podem ser exibidos no momento da importação, veja como proceder:",
                topics: [
                    {
                        icon: "fas fa-exclamation-triangle alert",
                        description:
                            "Se ao importar o balancete houver o alerta de “Inconsistência” pode ser que o seu arquivo esteja com alguma diferença de saldo, código da conta ou classificador."
                    },
                    {
                        icon: "fas fa-exclamation-circle warning",
                        description:
                            "Se ao importar o balancete houver o alerta de “Erro” pode ser que o seu arquivo esteja com um formato ou data incompatível."
                    }
                ],
                topicsHint: `Caso queira saber mais, acesse o card "Como importar o balancete sem erros" e "Como ajustar o balancete para o padrão Nucont".`,
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-importar-os-balancetes-contabeis"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Contabil.ComoResolver.Util.Sim",
                    "CentralAjuda.Importacao.Contabil.ComoResolver.Util.Nao"
                ]
            }
        }
    ],
    AccountingScenario: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `iifFO6pb428`,
                timer: "03:19 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente ao seu sistema contábil.",
                extLinks: [
                    {
                        label: "Criando cenário contábil",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/criando-cenarios-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Cenario.Contabil.Video.Util.Sim",
                    "CentralAjuda.Cenario.Contabil.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Quando criar cenário no módulo Contábil",
            icon: "fas fa-table",
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Abaixo estão listados as principais possibilidades para usar a função cenário",
                topics: [
                    "Para criar orçamentos ou ter uma visão contábil da empresa de períodos futuros.",
                    "Apresentar para um prospect, com objetivo dele visualizar os dados na plataforma.",
                    "Quando a empresa contábil não realiza as escrituras contábeis, mas deseja fazer a contabilidade consultiva.",
                    "Quando a contabilidade não atende e não tem acesso às informações da empresa.",
                    "Projeção de contabilidade para abertura de empresas."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/criando-cenarios-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Cenario.Contabil.QuandoCriar.Util.Sim",
                    "CentralAjuda.Cenario.Contabil.QuandoCriar.Util.Nao"
                ]
            }
        },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes sobre o cenário Contábil",
            icon: "fas fa-list",
            preview: "Tópicos",
            content: {
                topicsTitle: "",
                topics: [
                    "Ao analisar o cenário nos dashboards, deve-se trocar a base de dados em análise para o nome do cenário.",
                    "Contas personalizadas não estão disponíveis para o cenário contábil."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/criando-cenarios-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Cenario.Contabil.Consideracoes.Util.Sim",
                    "CentralAjuda.Cenario.Contabil.Consideracoes.Util.Nao"
                ]
            }
        },
        {
            type: "faq",
            label: "FAQ",
            labelTitle: "Dúvidas frequentes sobre o cenário Contábil",
            icon: "fas fa-question",
            preview: "Tópicos",
            content: {
                faqs: [
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Preciso ter dados no contábil para criar um cenário?",
                        answer: {
                            type: "text",
                            text: "Não, para criar um cenário contábil, você pode criar sem dados, inclusive para criar uma visão dos números de uma empresa que deseja iniciar as atividades."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> O que é a base de dados de um cenário?",
                        answer: {
                            type: "topics",
                            topics: [
                                "Base de dados original: são os dados dos balancetes importados, é possível criar um cenário, aproveitando todos os dados e alterando apenas uma ou outras contas necessárias.",
                                "Base Zero: sem aproveitar os dados do balancete importado ou quando não tem importação, é necessário digitar as contas para ter o cenário.",
                                "Base de dados de outro cenário: criação de outro (s) cenário (s) tendo como base os dados de um cenário anterior. "
                            ]
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Posso preencher somente as contas de resultados ou patrimoniais?",
                        answer: {
                            type: "text",
                            text: "Sim, pode ser preenchido apenas algumas contas para ser demonstrado somente um dashboard a qual deseja analisar ou compartilhar dash."
                        }
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/criando-cenarios-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Cenario.Contabil.FAQ.Util.Sim",
                    "CentralAjuda.Cenario.Contabil.FAQ.Util.Nao"
                ]
            }
        }
    ],
    CustomizationIndicator: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `lnyxqyrImsc`,
                timer: "02:41 min",
                description: "Estes dois links podem ser úteis",
                extLinks: [
                    {
                        label: "Criando um gráfico a partir de um indicador",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-customizar-graficos-e-dashboards"
                    },
                    {
                        label: "Veja mais detalhes",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/customizacao-de-indicadores-financeiros-fiscais-e-pessoais"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Indicador.Video.Util.Sim",
                    "CentralAjuda.Customizacao.Indicador.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Quando criar uma customização de indicador",
            icon: "fas fa-tasks",
            preview: "Tópicos",
            content: {
                topicsTitle: "",
                topics: [
                    "É indicado utilizar a customização quando os seus clientes <b>já estão habituados com os indicadores</b> padrões e demandam por uma análise personalizada.",
                    "Pode ser criada para <b>enriquecer suas análises e entregas de dash</b>, para aumentar a quantidade ou substituir o que já existe nos dashboards."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/customizacao-de-indicadores-financeiros-fiscais-e-pessoais"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Indicador.QuandoCriar.Util.Sim",
                    "CentralAjuda.Customizacao.Indicador.QuandoCriar.Util.Nao"
                ]
            }
        },
        {
            type: "glossary",
            label: "Dicas",
            labelTitle: "Glossário da customização de Indicador",
            icon: "fas fa-book",
            preview: "Tópicos",
            content: {
                glossary: [
                    {
                        list: [
                            "<b>Variável:</b> São contas dos planos de contas de algum módulo: Contábil, Financeiro, Fiscal ou Pessoal.",
                            "<b>Indicador:</b> São resultado de fórmulas entre variáveis ou indicadores.",
                            "<b>Gráfico:</b> Representação geométrica de um conjunto de dados, ou seja, podemos ter gráficos de variáveis e de indicadores. Na Nucont os gráficos ficam nos dashboards.",
                            "<b>Dashboards:</b> São painéis interativos, com diversos gráficos que representam os dados dos indicadores e variáveis."
                        ]
                    },

                    {
                        text: "Tipos de análises",
                        title: true
                    },
                    {
                        list: [
                            "<b>Mensal:</b> considera apenas o resultado do mês analisado.",
                            "<b>Acumulado:</b> considera o resultado acumulado do ano, ou seja, desde janeiro até o mês analisado."
                        ]
                    },
                    {
                        text: "Tipos de unidades",
                        title: true
                    },
                    {
                        list: [
                            "<b>Dinheiro:</b> O resultado do indicador é demonstrado em valores monetários, por exemplo: R$ 10.000,00 ou -R$ 2.500,00.",
                            "<b>Percentual:</b> O resultado do indicador é demonstrado em percentual, por exemplo: 15% ou 125%.",
                            "<b>Dias:</b> O resultado do indicador é demonstrado em número de dias, por exemplo: 9 dias ou 30 dias."
                        ]
                    },
                    {
                        text: "Tipos de polaridades",
                        title: true
                    },
                    {
                        list: [
                            "<b>Quanto maior melhor:</b> Quando o indicador aumenta é considerado um bom resultado, exemplo: Faturamento.",
                            "<b>Quanto menor melhor:</b> Quando o indicador aumenta é considerado um mau resultado ou um esforço crítico, exemplo: Custos e Despesas.",
                            "<b>Neutro:</b> Quando o indicador aumenta ou diminui não é possível analisar se foi um bom ou mau resultado. Exemplo: Atividades de Investimento e Financiamento."
                        ]
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/customizacao-de-indicadores-financeiros-fiscais-e-pessoais"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Indicador.Glossario.Util.Sim",
                    "CentralAjuda.Customizacao.Indicador.Glossario.Util.Nao"
                ]
            }
        }
    ],
    CustomizationChart: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `ZeRAZf1MmIY`,
                timer: "02:27 min",
                description: "",
                extLinks: [
                    {
                        label: "Criando um novo gráfico",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-customizar-graficos-e-dashboards"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Grafico.Video.Util.Sim",
                    "CentralAjuda.Customizacao.Grafico.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes da customização de gráfico",
            icon: "fas fa-chart-area",
            preview: "Tópicos",
            content: {
                topicsTitle: "",
                topics: [
                    "É necessário estar em uma das empresas a qual deseja customizar.",
                    "Ter algum dado no plano de contas de algum módulo.",
                    "É necessário inserir o gráfico criado em um novo dashboard ou algum existente."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Customizacao.Grafico.Consideracoes.Util.Sim",
                    "CentralAjuda.Customizacao.Grafico.Consideracoes.Util.Nao"
                ]
            }
        },
        {
            type: "customTopics",
            label: "Dicas",
            labelTitle: "Quando usar cada tipo de gráfico",
            icon: "fas fa-chart-pie",
            preview: "Tópicos",
            content: {
                customTopics: [
                    { title: true, text: "Até 1 indicador" },
                    {
                        topics: [
                            {
                                icon: "fas fa-circle-notch",
                                description:
                                    "<b>Círculo:</b> esse tipo de gráfico mostra o percentual, ou resultado de um determinado valor, por exemplo, o percentual do lucro líquido."
                            }
                        ]
                    },
                    { title: true, text: "Até 2 indicadores" },
                    {
                        topics: [
                            {
                                icon: "fas fa-chart-bar",
                                description:
                                    "<b>Barra e Linhas:</b> é um tipo de gráfico combinado entre barras e linhas, ajudando a analisar diferentes unidades de informação. Nesse exemplo, os valores monetários podem ser em barras e o percentual em linhas."
                            }
                        ]
                    },
                    { title: true, text: "Até 10 indicadores" },
                    {
                        topics: [
                            {
                                icon: "fas fa-chart-area",
                                description:
                                    "<b>Área:</b> são usados para encontrar tendências nos dados ao longo do tempo e possui sombreamento abaixo das linhas para mostrar a amplitude das tendências."
                            },
                            {
                                icon: "fas fa-chart-bar",
                                description:
                                    "<b>Barra:</b> é uma forma de resumir um conjunto de dados categóricos, utilizando de barras verticais de acordo com seus resultados."
                            },
                            {
                                icon: "fas fa-chart-bar",
                                description:
                                    "<b>Barras empilhadas:</b> exibem o tamanho relativo—como uma contagem, porcentagem ou outra variável numérica—de uma variável categórica, subdividida por cores com base em um subgrupo. Exemplo: Contas analíticas de uma conta sintética."
                            },
                            {
                                icon: "fas fa-chart-line",
                                description:
                                    "<b>Linhas:</b> são ideais para exibir tendências ao longo do tempo. Múltiplas escalas podem ser utilizadas no eixo Y para quando você quiser comparar diversas linhas com variações de valores significativamente diferentes."
                            },
                            {
                                icon: "fas fa-chart-pie",
                                description:
                                    "<b>Pizza:</b> são usados para representar porcentagens ou dividir resultado em várias partes. Se os indicadores forem de diferentes unidades de medida, irá ficar de difícil interpretação."
                            }
                        ]
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-customizar-graficos-e-dashboards"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Grafico.QuandoUsar.Util.Sim",
                    "CentralAjuda.Customizacao.Grafico.QuandoUsar.Util.Nao"
                ]
            }
        },
        {
            type: "alerts",
            label: "Erros",
            labelTitle: "Erros comuns na criação de um gráfico",
            icon: ["fas fa-exclamation-circle warning"],
            preview: "Tópicos",
            content: {
                topics: [
                    {
                        icon: "fas fa-exclamation-circle warning",
                        description:
                            "Ter uma quantidade de indicadores maior do que permite o tipo do gráfico. Exemplo: o gráfico do tipo “barras e linhas” permite apenas dois indicadores; o gráfico do tipo  “círculo” permite apenas um indicador."
                    }
                ],
                topicsHint: `Caso queira saber mais, acesse o card "Quando usar cada tipo de gráfico".`,
                extLinks: [],
                events: [
                    "CentralAjuda.Customizacao.Grafico.ErrosComuns.Util.Sim",
                    "CentralAjuda.Customizacao.Grafico.ErrosComuns.Util.Nao"
                ]
            }
        }
    ],
    CustomizationDashboard: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `JaYD9IQ3sDw`,
                timer: "02:16 min",
                description: "",
                extLinks: [
                    {
                        label: "Criando um novo dashboard",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/customizacao-dos-dashboards"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Dashboard.Video.Util.Sim",
                    "CentralAjuda.Customizacao.Dashboard.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Quando customizar o dashboards",
            icon: "fas fa-chart-area",
            preview: "Tópicos",
            content: {
                topics: [
                    "Após ter criado indicador(es) e gráfico(s).",
                    "Deixar o dashboard da forma que você ou o usuário da empresa mais gosta.",
                    "Selecionar os gráficos de sua preferência  que já existem nos atuais dashbords criando o seu próprio padrão de apresentação ou entrega.",
                    "Modificar as seções (divisão, coluna e altura) dos dashboards, substituir gráficos por outros da base ou customizados pela contabilidade.",
                    "Modificar a posição dos gráficos."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Customizacao.Dashboard.QuandoCustomizar.Util.Sim",
                    "CentralAjuda.Customizacao.Dashboard.QuandoCustomizar.Util.Nao"
                ]
            }
        },
        {
            type: "faq",
            label: "FAQ",
            labelTitle: "Dúvidas frequentes da customização de dashboards",
            icon: "fas fa-question",
            content: {
                faqs: [
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Quando crio um dashboard, qual o nome padrão?",
                        answer: {
                            type: "text",
                            text: "O nome do dashboard criado será “Dashboard em branco” você pode alterar esse nome a qualquer momento."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como alterar o nome do dashboard?",
                        answer: {
                            type: "text",
                            text: "Clique no botão “Editar nome do dashboard” ao passar o mouse próximo do nome atual."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como editar e customizar um dashboard que já existe?",
                        answer: {
                            type: "text",
                            text: "Clique no nome do dashboard para customizar um já existente, exemplo: clique no dashboard “Principal” para abrir a customização dele."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> O que compõe um dashboard?",
                        answer: {
                            type: "text",
                            text: "O dashboard é formado por seções, (divisão, colunas, altura) e gráficos."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como localizar o dashboard que eu criei e editei?",
                        answer: {
                            type: "text",
                            text: "Volte para o dashboard e clique no botão da visualização atual e selecione o nome do dashboard que você criou ou editou."
                        }
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/customizacao-dos-dashboards"
                    }
                ],
                events: [
                    "CentralAjuda.Customizacao.Dashboard.FAQ.Util.Sim",
                    "CentralAjuda.Customizacao.Dashboard.FAQ.Util.Nao"
                ]
            }
        }
    ],
    FinancialImport: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `Rau1Z1aibSQ`,
                timer: "02:24 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a importação no financeiro.",
                extLinks: [
                    {
                        label: "Importando dados no financeiro",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-inserir-dados-em-empresas-modulo-financeiro"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Financeiro.Video.Util.Sim",
                    "CentralAjuda.Importacao.Financeiro.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes na hora de importar",
            icon: "fas fa-list-ul",
            preview: "Tópicos",
            content: {
                topics: [
                    "A planilha modelo é gerada com base no plano de contas atual, ou seja, de acordo com as contas criadas, editadas e habilitadas.",
                    "Após importar a planilha, se tiver dados editados ou integrados serão sobrescritos."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Importacao.Financeiro.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Importacao.Financeiro.ConsideracoesImportantes.Util.Nao"
                ]
            }
        },
        { title: true, label: "O que pode dar errado" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Como fazer a importação sem erros",
            icon: "fas fa-exclamation-triangle",
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Abaixo estão listados os principais pontos de atenção sobre a importação:",
                topics: [
                    "Selecione o ano referente a fonte de dados antes de baixar a planilha modelo.",
                    "A planilha não aceita edição, pois é necessário ser uma cópia do plano de contas da Nucont. Se precisar editar, deve-se editar na plataforma e baixar uma nova planilha modelo.",
                    "Não alterar o nome do arquivo após baixar a planilha modelo."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-inserir-dados-em-empresas-modulo-financeiro"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Financeiro.ComoFazer.Util.Sim",
                    "CentralAjuda.Importacao.Financeiro.ComoFazer.Util.Nao"
                ]
            }
        }
    ],
    FinancialEdit: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `EJ-LHuzu8Cc`,
                timer: "03:09 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a edição de dados do financeiro.",
                extLinks: [
                    {
                        label: "Preenchendo dados no financeiro",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-inserir-dados-em-empresas-modulo-financeiro"
                    }
                ],
                events: [
                    "CentralAjuda.Edicao.Financeiro.Video.Util.Sim",
                    "CentralAjuda.Edicao.Financeiro.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes sobre a edição de dados",
            icon: "fas fa-list-ul",
            preview: "Tópicos",
            content: {
                topics: [
                    "Contas criadas fora do plano de contas padrão irão apenas para o dashboard Analítico.",
                    "Contas criadas no plano de contas padrão irão fazer parte dos indicadores do dashboard Principal.",
                    "É possível copiar o plano de contas de outra empresa.",
                    "Na Edição, as contas podem ser criadas, excluídas, renomeadas, habilitadas e desabilitadas.",
                    `Habilitações podem ser realizadas para as contas e para os gráficos:
                    <br><br>
                    Os <b>gráficos habilitados</b> demonstram o ícone ( <i class="fas fa-chart-bar icon"></i> ) ativo, isso indica que essa conta será representada por um gráfico nos dashboards;
                    <br><br>
                    As contas habilitadas demonstram o ícone ( <img src="assets/images/switch.png" style="max-height: 8px;height: 8px;"> ) ativo, isso indica que essa conta de sugestão da Nucont será habilitada no plano de contas.
                    `
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Financeiro.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Edicao.Financeiro.ConsideracoesImportantes.Util.Nao"
                ]
            }
        },
        {
            type: "simpleTopics",
            label: "Dicas",
            labelTitle: "Medida das contas na aba de edição de dados",
            icon: "fas fa-question",
            preview: "Tópicos",
            content: {
                topics: [
                    `<b>Dinheiro</b>
                   <br>
                   As informações são expressas em valores monetários, exemplo: R$10.000,00.`,
                    `
                   <b>Número Inteiro</b>
                   <br>
                    As informações são expressas em valores sem decimais, exemplo: 123 ou 65.
                   `,
                    `<b>Número Decimais</b>
                   <br>
                   As informações são expressas em valores com decimais, exemplo: 123,55 ou 65,00.`,
                    `<b>Percentual</b>
                   <br>
                   As informações são expressas em valores percentuais, exemplo: 12,56% ou 13,00%.
                   `,
                    `<b>Dias</b>
                   <br>
                   As informações são expressas em quantidade de dias, exemplo: 15 ou 30.
                   `
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Financeiro.MedidaDasContas.Util.Sim",
                    "CentralAjuda.Edicao.Financeiro.MedidaDasContas.Util.Nao"
                ]
            }
        },
        { title: true, label: "O que pode dar errado" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Principais pontos de atenção ao preencher os dados",
            icon: "fas fa-exclamation-triangle",
            preview: "Tópicos",
            content: {
                topicsTitle: "",
                topics: [
                    "É necessário preencher os valores das contas filhas para a conta mãe ser o totalizador.",
                    "Contas criadas fora do plano de contas padrão irão apenas para o dashboard Analítico.",
                    "Se as contas criadas necessitam fazer parte de algum indicador no dashboard Principal é necessário criar contas analíticas entre as principais contas sintéticas."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Financeiro.PrincipaisPontos.Util.Sim",
                    "CentralAjuda.Edicao.Financeiro.PrincipaisPontos.Util.Nao"
                ]
            }
        }
    ],
    FinancialScenario: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `-I9NRmT3G5s`,
                timer: "03:34 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente ao cenário no financeiro.",
                extLinks: [
                    {
                        label: "Criando cenários no financeiro",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-inserir-dados-em-empresas-modulo-financeiro"
                    }
                ],
                events: [
                    "CentralAjuda.Cenario.Financeiro.Video.Util.Sim",
                    "CentralAjuda.Cenario.Financeiro.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle:
                "Considerações importantes sobre o cenário no financeiro",
            icon: "fas fa-list-ul",
            preview: "Tópicos",
            content: {
                topics: [
                    "Cenário financeiro é importante para criar orçamento ou visões futuras dos resultados de uma gestão financeira.",
                    "Comparar cenários otimistas e pessimistas de certos períodos.",
                    "Somente é possível criar cenário financeiro se possuir dados da edição ou da importação.",
                    "Ao criar um cenário, o plano de contas será um reflexo do plano da edição.",
                    "Um cenário pode ser preenchido apenas com algumas contas para ser visualizado somente um dashboard a qual deseja analisar ou compartilhar dash.",
                    "Ao analisar o cenário nos dashboards, deve-se trocar a base de dados em análise para o nome do cenário."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Cenario.Financeiro.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Cenario.Financeiro.ConsideracoesImportantes.Util.Nao"
                ]
            }
        }
    ],
    Parameterization: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar | Parte 1",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `z8zTe9iXiL4`,
                timer: "03:10 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo de uma parametrização.",
                extLinks: [
                    {
                        label: "Como parametrizar na Nucont",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/parametrizacao-modulo-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Nao"
                ]
            }
        },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar | Parte 2",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `LCeTZcytt3c`,
                timer: "03:08 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo de uma parametrização.",
                extLinks: [
                    {
                        label: "Como parametrizar na Nucont",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/parametrizacao-modulo-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes na hora de parametrizar",
            icon: "fas fa-tasks",
            preview: "Tópicos",
            content: {
                topics: [
                    "As contas que estiverem 'apagadas' não precisam ser parametrizadas pois são a somatória das contas filhas.",
                    "Caso apareça a duplicidade de alguma conta, isso significa que foi importado balancetes com planos de contas diferentes. É necessário excluir o plano de contas dentro do Nucont e importar novamente os balancetes, mas com um único plano de contas.",
                    "Quando uma empresa não está parametrizada, os saldos das contas ficam zerados. Indicando que a parametrização não foi realizada.",
                    "Quando o valor do Ativo está diferente de Passivo + Receita - Custos - Despesas é provável que alguma conta não foi parametrizada corretamente ou parametrizada em duplicidade."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.ConsideracoesImportantes.Util.Nao"
                ]
            }
        },
        {
            type: "faq",
            label: "FAQ",
            labelTitle: "Dúvidas frequentes sobre a parametrização",
            icon: "fas fa-question",
            preview: "Tópicos",
            content: {
                title: "Veja quais são as dúvidas frequentes dos nossos usuários:",
                faqs: [
                    {
                        question:
                            "<span class='question-prefix'>D:</span> O que acontece se eu não parametrizar?",
                        answer: {
                            type: "text",
                            text: "Quando uma empresa não está parametrizada, os gráficos das contas ficam zerados. Indicando que a parametrização não foi realizada."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Quando é preciso parametrizar?",
                        answer: {
                            type: "text",
                            text: "É necessário fazer a parametrização após a primeira importação dos dados contábeis, seja por integração ou por importação dos balancetes."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Preciso parametrizar todo mês?",
                        answer: {
                            type: "text",
                            text: "Não é necessário parametrizar todo mês. Somente uma vez por empresa e a parametrização ficará salva."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Posso parametrizar uma vez e replicar para outras empresas?",
                        answer: {
                            type: "text",
                            text: "Pode sim, parametrizar uma empresa e replicar a parametrização para outras empresas, contando que seja o mesmo plano de contas."
                        }
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/parametrizacao-modulo-contabil"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Nao"
                ]
            }
        },
        { title: true, label: "O que pode dar errado" },
        {
            type: "alerts",
            label: "Alertas",
            labelTitle: "Como é feito as conferências da parametrização",
            icon: [
                "fas fa-check top small",
                "fas fa-check center alert small",
                "fas fa-check bottom small"
            ],
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Existe um tipo de alerta que pode ser exibido após a conferência dos dados:",
                topics: [
                    {
                        icon: "fas fa-exclamation-triangle alert",
                        description: `Quando o <i class="fas fa-check icon alert"></i> da conferência estiver em amarelo, significa que o valor do Ativo está diferente de Passivo + Receita - Custos - Despesas. Isso ocorre, pois alguma conta não foi parametrizada corretamente ou parametrizada em duplicidade.`
                    }
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.ComoFeito.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.ComoFeito.Util.Nao"
                ]
            }
        }
    ],
    PersonnelImport: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `N-6JbBc-Jis`,
                timer: "01:55 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a importação do Pessoal.",
                extLinks: [
                    {
                        label: "Importando dados do eSocial",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/importacao-esocial"
                    },
                    {
                        label: "Importando dados do Departamento Pessoal",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/departamento-pessoal"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Pessoal.Video.Util.Sim",
                    "CentralAjuda.Importacao.Pessoal.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes na hora de importar",
            icon: "fas fa-tasks",
            preview: "Tópicos",
            content: [
                {
                    title: "Com o eSocial",
                    topics: [
                        "Ao importar o arquivo irá habilitar um novo plano de contas, portanto não sobrescreve o plano de contas atual.",
                        "É aceito o arquivo .xml ou .zip"
                    ]
                },
                {
                    title: "Com a planilha modelo:",
                    topics: [
                        "A planilha modelo é gerada com base no plano de contas atual, ou seja, de acordo com as contas criadas, editadas e habilitadas.",
                        "Após importar a planilha, se tiver dados editados ou integrados serão sobrescritos."
                    ]
                }
            ]
        },
        { title: true, label: "O que pode dar errado" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Como fazer a importação sem erros",
            icon: "fas fa-exclamation-triangle",
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Abaixo estão listados os principais pontos de atenção sobre a importação:",
                topics: [
                    "Alterar o nome do arquivo após baixar a planilha modelo.",
                    "A planilha não aceita edição, pois é necessário ser uma cópia do plano de contas da Nucont. Se precisar editar, deve-se editar na plataforma e baixar uma nova planilha modelo.",
                    "Não selecionar o ano correto referente a fonte de dados antes de baixar a planilha modelo."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Pessoal.ComoFazer.Util.Sim",
                    "CentralAjuda.Importacao.Pessoal.ComoFazer.Util.Nao"
                ]
            }
        }
    ],
    PersonnelEdit: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `a5Ds-1hZ4RE`,
                timer: "04:50 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a edição de dados do Pessoal.",
                extLinks: [
                    {
                        label: "Editando dados no Departamento Pessoal",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.Edicao.Pessoal.Video.Util.Sim",
                    "CentralAjuda.Edicao.Pessoal.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "simpleTopics",
            label: "Dicas",
            labelTitle: "Principais funcionalidades na edição de dados",
            icon: "fas fa-table",
            preview: "Tópicos",
            content: {
                topics: [
                    `<b>Criar conta</b>
                   <br>
                   <br>
                   É permitido criar contas mães ou contas filhas no seu plano de contas. Também é possível criar, excluir, renomear, habilitar ou desabilitar as contas. Editar os valores e alterar as medidas de cada conta.`,
                    `<b>Copiar plano de contas</b>
                   <br>
                   <br>
                   É possível copiar o plano de contas de outra empresa.
                   <br>
                   <br>
                   <b>Lembre-se:</b> copiando o plano de contas de outra empresa, os dados já preenchidos serão perdidos.`,
                    `<b>Copiar o Faturamento do Fiscal</b>
                   <br>
                   <br>
                   É possível copiar o Faturamento do departamento Fiscal e deixar sincronizado. A medida que vai inserindo dados do Faturamento no Fiscal, é automaticamente copiado para o Departamento Pessoal.
                   <br>
                   <br>
                   <b>Lembre-se:</b> se houver quaisquer dados de faturamento no Pessoal, eles serão sobrescritos.`
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Pessoal.PrincipaisFuncionalidades.Util.Sim",
                    "CentralAjuda.Edicao.Pessoal.PrincipaisFuncionalidades.Util.Nao"
                ]
            }
        },
        {
            type: "simpleTopics",
            label: "Dicas",
            labelTitle: "Medida das contas na aba de edição de dados",
            icon: "fas fa-list-ul",
            preview: "Tópicos",
            content: {
                topics: [
                    `<b>Dinheiro</b>
                    <br>
                    <br>
                    As informações são expressas em valores monetários, exemplo, R$10.000,00`,
                    `<b>Número Inteiro</b>
                    <br>
                    <br>
                    As informações são expressas em valores sem decimais, exemplo, 123 ou 65`,
                    `<b>Número Decimais</b>
                    <br>
                    <br>
                    As informações são expressas em valores com  decimais, exemplo, 123,55 ou 65,00`,
                    `<b>Percentual</b>
                    <br>
                    <br>
                    As informações são expressas em valores percentuais, exemplo, 12,56% ou 13,00%`,
                    `<b>Dias</b>
                    <br>
                    <br>
                    As informações são expressas em quantidade de dias, exemplo, 15 ou 30`
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Pessoal.MedidaDasContas.Util.Sim",
                    "CentralAjuda.Edicao.Pessoal.MedidaDasContas.Util.Nao"
                ]
            }
        },
        {
            type: "faq",
            label: "FAQ",
            labelTitle: "Dúvidas frequentes sobre a edição de dados Pessoal",
            icon: "fas fa-question",
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Veja quais são as dúvidas frequentes dos nossos usuários:",
                faqs: [
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Posso copiar o plano de contas de qualquer empresa?",
                        answer: {
                            type: "text",
                            text: "Sim, é possível copiar o plano de contas de uma empresa para todas as outras empresas cadastradas."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Posso fazer importação via planilha e depois inserir novos valores na tabela de edição?",
                        answer: {
                            type: "text",
                            text: "Sim, pode editar os valores inseridos via planilha. Um ponto de atenção é gerar uma nova planilha para não inserir novos meses e ter o valor antes da edição."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como faço para copiar os dados do balancete?",
                        answer: {
                            type: "text",
                            text: `A partir dos balancetes importados e parametrizados, em Dados > Editar, tem a opção de “Preencher os dados com” e aí posteriormente selecionar a opção de copiar os dados do balancete. 
                                <br>
                                <br>
                                O sistema lista as contas que serão copiadas e sincronizadas. Com a cópia ativa não é possível editar os dados.`
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Copiei o plano de contas de uma empresa e apagou todos meus dados.",
                        answer: {
                            type: "text",
                            text: "Quando escolhemos a opção de copiar o plano de contas de outra empresa, consideramos como um novo plano de contas, com isso, todos os dados já inseridos anteriormente serão apagados."
                        }
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.Edicao.Pessoal.FAQ.Util.Sim",
                    "CentralAjuda.Edicao.Pessoal.FAQ.Util.Nao"
                ]
            }
        }
    ],
    TaxImport: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `DGmyCY0hxAo`,
                timer: "01:50 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a importação no fiscal.",
                extLinks: [
                    {
                        label: "Importando dados no Fiscal",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/input-de-dados-fiscal"
                    },
                    {
                        label: "Importando com o PGDAS",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-usar-a-funcionalidade-analises-pgdas"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Fiscal.Video.Util.Sim",
                    "CentralAjuda.Importacao.Fiscal.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "multiTopics",
            label: "Dicas",
            labelTitle: "Considerações importantes na hora de importar",
            icon: "fas fa-tasks",
            preview: "Tópicos",
            content: {
                topics: [
                    {
                        topicsTitle: "Com o PGDAS (Simples Nacional):",
                        topics: [
                            "Para o PGDAS (Simples Nacional) é necessário importar o arquivo declaratório, em PDF.",
                            "Ao importar um arquivo PGDAS, irá habilitar um novo plano de contas, portanto não sobrescreve o plano de contas atual."
                        ]
                    },
                    {
                        topicsTitle: "Com a planilha modelo:",
                        topics: [
                            "A planilha modelo é gerada com base no plano de contas atual, ou seja, de acordo com as contas criadas, editadas e habilitadas;",
                            "Após importar a planilha, se houverem dados editados ou integrados, serão sobrescritos."
                        ]
                    }
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Importacao.Fiscal.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Importacao.Fiscal.ConsideracoesImportantes.Util.Nao"
                ]
            }
        },
        { title: true, label: "O que pode dar errado" },
        {
            type: "multiTopics",
            label: "Dicas",
            labelTitle: "Como fazer a importação sem erros",
            icon: "fas fa-exclamation-triangle",
            preview: "Tópicos",
            content: {
                topics: [
                    {
                        topicsTitle:
                            "Principais pontos de atenção sobre a importação do PGDAS:",
                        topics: [
                            "PGDAS extrato não é o documento de importação, apenas o PGDAS Declaratório.",
                            'Arquivo pdf tipo imagem não é aceito, o arquivo tradicional é: "pdf tipo texto". '
                        ]
                    },
                    {
                        topicsTitle:
                            "Principais pontos de atenção sobre a importação da Planilha Modelo:",
                        topics: [
                            "Alterar o nome do arquivo após baixar a planilha modelo.",
                            "A planilha não aceita edição, pois é necessário ser uma cópia do plano de contas da Nucont. Se precisar editar, deve-se editar na plataforma e baixar uma nova planilha modelo.",
                            "Não selecionar o ano correto referente a fonte de dados antes de baixar a planilha modelo."
                        ]
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-usar-a-funcionalidade-analises-pgdas"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Fiscal.ComoFazer.Util.Sim",
                    "CentralAjuda.Importacao.Fiscal.ComoFazer.Util.Nao"
                ]
            }
        }
    ],
    TaxEdit: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `LoShb5trgiQ`,
                timer: "04:08 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a edição de dados do Fiscal.",
                extLinks: [
                    {
                        label: "Editando dados no Departamento Fiscal",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.Edicao.Fiscal.Video.Util.Sim",
                    "CentralAjuda.Edicao.Fiscal.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "simpleTopics",
            label: "Dicas",
            labelTitle: "Principais funcionalidades na edição de dados",
            icon: "fas fa-table",
            preview: "Tópicos",
            content: {
                topics: [
                    `<b>Criar conta</b>
                   <br>
                   <br>
                   É permitido criar contas mães ou contas filhas no seu plano de contas. Também é possível criar, excluir, renomear, habilitar ou desabilitar as contas. Editar os valores e alterar as medidas de cada conta.`,
                    `<b>Copiar plano de contas</b>
                   <br>
                   <br>
                   É possível copiar o plano de contas de outra empresa.
                   <br>
                   <br>
                   <b>Lembre-se:</b> copiando o plano de contas de outra empresa, os dados já preenchidos serão perdidos.`,
                    `<b>Copiar dados do Balancete</b>
                    <br>
                    <br>
                    É possível copiar os dados do balancete e deixar sincronizado. A medida que vai inserindo novos dados no Departamento Contábil, é automaticamente copiado para o Departamento Fiscal.
                    <br>
                    <br>
                    <b>Lembre-se:</b> copiando os dados do balancete, os dados já preenchidos serão perdidos.`
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Fiscal.PrincipaisFuncionalidades.Util.Sim",
                    "CentralAjuda.Edicao.Fiscal.PrincipaisFuncionalidades.Util.Nao"
                ]
            }
        },
        {
            type: "simpleTopics",
            label: "Dicas",
            labelTitle: "Medida das contas na aba de edição de dados",
            icon: "fas fa-list-ul",
            preview: "Tópicos",
            content: {
                topics: [
                    `<b>Dinheiro</b>
                    <br>
                    <br>
                    As informações são expressas em valores monetários, exemplo, R$10.000,00`,
                    `<b>Número Inteiro</b>
                    <br>
                    <br>
                    As informações são expressas em valores sem decimais, exemplo, 123 ou 65`,
                    `<b>Número Decimais</b>
                    <br>
                    <br>
                    As informações são expressas em valores com  decimais, exemplo, 123,55 ou 65,00`,
                    `<b>Percentual</b>
                    <br>
                    <br>
                    As informações são expressas em valores percentuais, exemplo, 12,56% ou 13,00%`,
                    `<b>Dias</b>
                    <br>
                    <br>
                    As informações são expressas em quantidade de dias, exemplo, 15 ou 30`
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Edicao.Fiscal.MedidaDasContas.Util.Sim",
                    "CentralAjuda.Edicao.Fiscal.MedidaDasContas.Util.Nao"
                ]
            }
        },
        {
            type: "faq",
            label: "FAQ",
            labelTitle: "Dúvidas frequentes sobre a edição de dados Fiscal",
            icon: "fas fa-question",
            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Veja quais são as dúvidas frequentes dos nossos usuários:",
                faqs: [
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Posso copiar o plano de contas de qualquer empresa?",
                        answer: {
                            type: "text",
                            text: "Sim, é possível copiar o plano de contas de uma empresa para todas as outras empresas cadastradas."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Posso fazer importação via planilha e depois inserir novos valores na tabela de edição?",
                        answer: {
                            type: "text",
                            text: "Sim, pode editar os valores inseridos via planilha. Um ponto de atenção é gerar uma nova planilha para não inserir novos meses e ter o valor antes da edição."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como faço para copiar os dados do balancete?",
                        answer: {
                            type: "text",
                            text: `A partir dos balancetes importados e parametrizados, em Dados > Editar, tem a opção de “Preencher os dados com” e aí posteriormente selecionar a opção de copiar os dados do balancete. 
                                <br>
                                <br>
                                O sistema lista as contas que serão copiadas e sincronizadas. Com a cópia ativa não é possível editar os dados.`
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Copiei o plano de contas de uma empresa e apagou todos meus dados.",
                        answer: {
                            type: "text",
                            text: "Quando escolhemos a opção de copiar o plano de contas de outra empresa, consideramos como um novo plano de contas, com isso, todos os dados já inseridos anteriormente serão apagados."
                        }
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.Edicao.Fiscal.FAQ.Util.Sim",
                    "CentralAjuda.Edicao.Fiscal.FAQ.Util.Nao"
                ]
            }
        }
    ],
    NPS: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `UoNvqnK5NXo`,
                timer: "02:55 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente ao NPS",
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/nps"
                    }
                ],
                events: [
                    "CentralAjuda.NPS.Video.Util.Sim",
                    "CentralAjuda.NPS.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes sobre a pesquisa de NPS",
            icon: "fas fa-tasks",
            preview: "Tópicos",
            content: {
                topicsTitle: "",
                topics: [
                    "O “status” é referente ao período filtrado",
                    "Os clientes que responderem, será enviado novamente uma nova pesquisa após 90 dias da resposta.",
                    "O e-mail editado na tabela do NPS não é alterado nos dados cadastrais da empresa.",
                    "Não é possível enviar para dois e-mails de uma mesma empresa.",
                    `Para reenviar um NPS*, basta ir à linha da empresa na tabela, clicar nos três pontinhos ( <i class= "fas fa-ellipsis-v"></i>  ) e selecionar “Enviar NPS”, desta forma irá enviar a pesquisa fora do programado. *Essa função só está disponível após ativar o envio automático.`,
                    "Todas as empresas estão disponíveis para enviar as pesquisas."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.NPS.Consideracoes.Util.Sim",
                    "CentralAjuda.NPS.Consideracoes.Util.Nao"
                ]
            }
        },
        {
            type: "simpleTopicsIcon",
            label: "Dicas",
            labelTitle: "O que promotor, neutro e detrator significa?",
            icon: [
                "far fa-smile align-left success small",
                "far fa-meh center alert small",
                "far fa-frown align-right warning small"
            ],
            preview: "Tópicos",
            content: {
                topics: [
                    {
                        icon: "far fa-smile success",
                        title: "Promotores (nota 9 ou 10)",
                        description:
                            "Pessoas que dão esta nota realmente enxergam o valor no seu serviço e realmente sentem diferença na sua contabilidade. São clientes leais, mantendo-se ligados a contabilidade e recomendando-a para amigos ou colegas."
                    },
                    {
                        icon: "far fa-meh alert",
                        title: "Neutros (nota 7 ou 8)",
                        description:
                            "São clientes não engajados com a contabilidade. Passivamente satisfeitos, porém desejam melhorias, e você deve manter-se atento a eles."
                    },
                    {
                        icon: "far fa-frown warning",
                        title: "Detratores (0 a 6)",
                        description:
                            "São clientes insatisfeitos com o serviço e podem migrar para a próxima zona rapidamente. Eles são mais custosos, pois precisam de mais suporte e atenção."
                    }
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.NPS.OqueSignifica.Util.Sim",
                    "CentralAjuda.NPS.OqueSignifica.Util.Nao"
                ]
            }
        },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "O que fazer quando receber a nota de detrator",
            icon: ["far fa-frown center warning"],
            preview: "Tópicos",
            content: {
                topics: [
                    "Levante as causas da insatisfação",
                    "Desculpar-se com o cliente e apresentar soluções para resolver tal problema",
                    "Procure fazer um acompanhamento imediato"
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.NPS.OqueFazer.Util.Sim",
                    "CentralAjuda.NPS.OqueFazer.Util.Nao"
                ]
            }
        },
        {
            type: "faq",
            label: "FAQ",
            labelTitle: "Dúvidas frequentes sobre a pesquisa de NPS",
            icon: "fas fa-question",
            preview: "Tópicos",
            content: {
                faqs: [
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como desativar a automação das pesquisas?",
                        answer: {
                            type: "text",
                            text: `Para desativar, basta ir na empresa que deseja, clicar no ícone de ( <i class="fas fa-ellipsis-v "></i> ) e desabilitar o “Envio do NPS”.`
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> É possível enviar para mais de uma empresa?",
                        answer: {
                            type: "text",
                            text: `Sim, em "Enviar NPS" você pode selecionar quantas empresas quiser.`
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Como é calculada a média do meu NPS?",
                        answer: {
                            type: "text",
                            text: "Somam-se as notas recebidas e divide-se o resultado pelo número de respostas."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Quando se deve enviar uma nova pesquisa?",
                        answer: {
                            type: "text",
                            text: "O ideal é enviar a cada 3 meses para você acompanhar a satisfação do seu cliente ao longo do ano."
                        }
                    },
                    {
                        question:
                            "<span class='question-prefix'>D:</span> Onde visualizo o histórico de respostas?",
                        answer: {
                            type: "text",
                            text: `Na linha da empresa desejada clique no ícone ( <i class="fas fa-eye"></i> ) para visualizar todas as respostas.`
                        }
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: ""
                    }
                ],
                events: [
                    "CentralAjuda.NPS.FAQ.Util.Sim",
                    "CentralAjuda.NPS.FAQ.Util.Nao"
                ]
            }
        }
    ],
    IntegrationPGDASFiscal: [
        { title: true, label: "Primeiros passos" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `rkdyUjyScvg`,
                timer: "03:10 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo referente a Automação PGDAS.",
                extLinks: [
                    {
                        label: "Como integrar o PGDAS",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "É essencial saber" },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Precondições para integração:",
            icon: "fas fa-tasks",
            preview: "Dicas",
            content: {
                topics: [
                    "É necessário ter o cadastro das empresas já realizado na Carteira Consultiva.",
                    "É necessário ter o regime de tributação informado nas empresas."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.ConsideracoesImportantes.Util.Nao"
                ]
            }
        },
        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Informações do Certificado Digital:",
            icon: "fas fa-tasks",
            preview: "Dicas",
            content: {
                topics: [
                    "O Certificado da Contabilidade deve ter o mesmo CNPJ que esta vinculado as procurações das empresas.",
                    "O Certificado deve ter o mesmo CNPJ e Razão Social cadastrados na Nucont.",
                    "O Certificado não pode ter expirado.",
                    "Lembre-se de digitar ou colar sua senha antes de selecionar o certificado.",
                    "É aceito apenas Certificado eCNPJ."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Nao"
                ]
            }
        },
        { title: true, label: "A importação falhou?" },
        {
            type: "topics",
            label: "Alertas",
            labelTitle: "A integração falhou?",
            icon: "fas fa-exclamation-triangle alert",
            preview: "Tópicos",
            content: {
                iconTopic: {
                    size: "5px",
                    class: "fas fa-circle gray-style"
                },
                topicsTitle: "Possíveis erros e inconsistências",
                topics: [
                    "Se não tiver procuração eletrônica das empresas.",
                    "eCPF não é aceito para integração.",
                    "As procurações das empresas estarem vinculadas a outro CNPJ ou CPF.",
                    "A empresa não é do regime de tributação do Simples Nacional.",
                    "Erro da senha antes de inserir o certificado digital.",
                    "Razão Social do certificado."
                ],
                extLinks: [],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.ComoFeito.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.ComoFeito.Util.Nao"
                ]
            }
        }
    ],
    centerReportsAutomations: [
        { title: true, label: "Primeiros passos" },

        {
            type: "topics",
            label: "Dicas",
            iconImg: { size: "24px", url: "/assets/icons/nanda-icon.svg" },
            labelTitle: "Ative o piloto automático",

            preview: "Tópicos",
            content: {
                topicsTitle:
                    "Veja como funciona o Dash pelo piloto automático:",
                topics: [
                    "O Dash é gerado para todos os módulos e para todas as empresas com dados.",
                    "É gerado 7 dias após a data de ativação, para os últimos meses com dados.",
                    "Serão compartilhados 5 dias após a geração para aquelas empresas com contatos cadastrados."
                ],
                extLinks: [
                    {
                        label: "Como cadastrar empresas e contatos",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
                    },
                    {
                        label: "Como realizar input de dados",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.ConsideracoesImportantes.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.ConsideracoesImportantes.Util.Nao"
                ]
            }
        },
        { title: true, label: "Saiba por onde começar" },
        {
            type: "video",
            label: "Tutorial",
            labelTitle: "Saiba por onde começar",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            content: {
                videoId: `rmz2TlncDQk`,
                timer: "07:43 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo da automação de dash. Realize também a automação quanto a importação automática do módulo fiscal:",
                extLinks: [
                    {
                        label: "Automação de Dash",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
                    },
                    {
                        label: "Como integrar automático com o PGDAs",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.Video.Util.Nao"
                ]
            }
        },

        {
            type: "topics",
            label: "Dicas",
            labelTitle: "Considerações importantes sobre a automação",
            icon: "fas fa-table",
            preview: "Tópicos",
            content: {
                topics: [
                    "É necessário ter o cadastro das empresas e contatos para a opção de compartilhamento automático.",
                    "As empresas precisam estar ativas e conter dados em algum dos módulos.",

                    "Os contatos podem ser cadastrados no final da configuração da automação, “Ações” ao editar a automação ou “Criar Automação”",
                    'Todos os Dashes agendados pela automação estarão na aba de "Central de Dash".',
                    'É possível compartilhar os Dashes manualmente após gerados na aba de "Central de Dash"'
                ],
                extLinks: [
                    {
                        label: "Como cadastrar empresas e contatos",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-cadastrar-empresas"
                    },
                    {
                        label: "Como realizar input de dados",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/pt_BR"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Nao"
                ]
            }
        },

        {
            type: "topics",
            label: "Regras",
            labelTitle: "Entenda como funciona o Piloto Automático",
            icon: "fas fa-tasks",
            preview: "Tópicos",
            content: {
                topics: [
                    "Terá o Dash gerado todas as empresas ativas e de todos os módulos com dados.",
                    "A geração do Dash será realizada 7 dias após a ativação.",
                    "O período do Dash será sempre de dados mensais e são do dashboard principal de cada módulo.",
                    "É possível ativar o compartilhamento automático, que acontece 5 dias após a geração.",
                    "Os Dashes são gerados a cada 30 dias."
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
                    }
                ],
                events: [
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Sim",
                    "CentralAjuda.Parametrizacao.Contabil.FAQ.Util.Nao"
                ]
            }
        },
        // { title: true, label: "Entenda como funciona o Piloto Automático" },

        { title: true, label: "Possíveis erros no Dash automático" },
        {
            type: "multiTopics",
            label: "Alertas",
            labelTitle: "Possíveis erros no Dash automático",
            icon: "fas fa-exclamation-circle warning",
            preview: "Tópicos",
            content: {
                topics: [
                    {
                        customIcon: "fas fa-exclamation-triangle alert",
                        topics: [
                            'Ao gerar o Dash, caso não existam dados no módulo agendado, o Dash não será gerado e será encaminhado para a "Central de Dash" com uma mensagem de erro.'
                        ]
                    },
                    {
                        customIcon: "fas fa-exclamation-triangle warning",
                        topics: [
                            'Ao ativar o compartilhamento automático, se houver empresas sem contatos cadastrados, o Dash não será compartilhada com essas empresas. Para resolver isso, basta adicionar o contato na coluna "Ações".'
                        ]
                    }
                ],
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.Fiscal.ComoFazer.Util.Sim",
                    "CentralAjuda.Importacao.Fiscal.ComoFazer.Util.Nao"
                ]
            }
        }
    ],
    integrationsContaAzul: [
        { title: true, label: "Primeiros passos" },

        {
            type: "video",
            label: "Tutorial",
            icon: "fas fa-play",
            iconPreview: "fab fa-youtube",
            preview: "Vídeos",
            labelTitle: "Saiba por onde começar",
            content: {
                topics: [
                    `A integração é exclusiva com <b> Conta Azul Mais </b>, não é possível integrar com o login do Conta Azul Pro.`
                ],
                videoId: `xXgNF7nrrck`,
                step: "Primeiros passos",
                timer: "02:41 min",
                description:
                    "Clique no link abaixo para visualizar o passo a passo da integração com o Conta Azul.",

                extLinks: [
                    {
                        label: "Integração com Conta Azul",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-conta-azul-modulo-financeiro"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.ContaAzul.SaibaPorOndeComecar.Video.Util.Sim",
                    "CentralAjuda.Importacao.ContaAzul.SaibaPorOndeComecar.Video.Util.Nao"
                ]
            }
        },

        { title: true, label: "Como Integrar" },

        {
            type: "video",
            label: "Dicas",
            icon: "fas fa-tasks",
            iconPreview: "fab fa-youtube",
            labelTitle: "Como Obter o código MFA no Conta Azul",
            preview: "Vídeos | Tópicos",
            content: {
                topics: [
                    `O código MFA que usaremos na tela da Nucont é o <b> código de vários dígitos </b>, exemplo: BNS7H5MNYV4D7FUWJLWZL... Diferente do código do aplicativo autenticador do celular.`
                ],
                topicCheck: true,
                videoId: `Vjy5plDiX7w`,
                step: "Código MFA disponível para integração",
                timer: "06:42 min",
                events: [
                    "CentralAjuda.Importacao.ContaAzul.CodigoMFAObter.Video.Util.Sim",
                    "CentralAjuda.Importacao.ContaAzul.CodigoMFAObter.Video.Util.Nao"
                ]
            }
        },
        { title: true, label: "Problemas com código" },
        {
            type: "video",
            label: "Ajuda",
            icon: "fas fa-exclamation-triangle",
            iconPreview: "fab fa-youtube",
            labelTitle: "Como solicitar reset do seu código MFA no Conta Azul",
            preview: "Vídeos | Tópicos",
            content: {
                topics: [
                    `Para cadastro do Código MFA é necessário que você possua em seu celular um <b> aplicativo de autenticação </b>, recomendamos o Google Authenticator.`,
                    `Copie o código MFA que está abaixo do QR code. (Dica: salve em um bloco de notas)`,
                    `Se você fizer o login no Conta Azul Mais é porque já tem o código MFA cadastrado.`,
                    `Caso precise do código, entre em contato com o suporte e solicite o reset do MFA (lembre-se de excluir também do seu aplicativo de autenticação).`
                ],
                topicCheck: true,
                videoId: `0sI1Ixi5UJo`,
                step: "Como solicitar suporte da Conta Azul",
                timer: "01:53 min",
                extLinks: [
                    {
                        label: "Ver mais",
                        href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-conta-azul-modulo-financeiro"
                    }
                ],
                events: [
                    "CentralAjuda.Importacao.ContaAzul.CodigoMFAReset.Video.Util.Sim",
                    "CentralAjuda.Importacao.ContaAzul.CodigoMFAReset.Video.Util.Nao"
                ]
            }
        }
    ]
};
